import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { mergeMap, catchError, filter } from "rxjs/operators";
import { ofType } from "redux-observable";
import { authHeaders, getOrganisationBaseUrl } from "frame";
import Types from "../actions/types";
import { onRemoveFailed, onRemoveSuccess } from "../actions";

const leaveTypeRemoveEffect = (action$, state$) =>
	action$.pipe(
		ofType(Types.LEAVE_TYPE_DELETE_REQUESTED),
		filter(() => state$.value.organisations.currentOrganisation),
		mergeMap(({ payload }) =>
			ajax
				.delete(
					`${getOrganisationBaseUrl(
						state$.value
					)}/organisation-leave-type/delete/${payload}`,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(onRemoveSuccess(ajaxResponse.response))
					),
					catchError((error) => of(onRemoveFailed(error)))
				)
		)
	);

export default leaveTypeRemoveEffect;
